import * as React from "react";

import { Goto } from "@/shared/navigation";

interface NavigationContext {
  goto: Goto;
}

export const NavigationContext = React.createContext<NavigationContext | null>(
  null,
);

export const useNavigation = () => {
  const navigationContext = React.useContext(NavigationContext);
  if (!navigationContext) {
    throw new Error("NavigationContext is null", {
      cause: {
        reason: "NavigationContext is accessed outside a NavigationProvider",
      },
    });
  }
  return navigationContext;
};
